<template>
  <div class="kids-store-page">
    <MainNavbar />
    <KidsStoreNav />

    <main class="kids-store">
      <header class="kids-store__intro">
        <p class="kids-store__kicker">
          <i class="fa-solid fa-child-reaching" aria-hidden="true" />
          IpromiseAfrica · Kids sports
        </p>
        <h1 class="kids-store__title">Kids Sports Store</h1>
        <p class="kids-store__lead">
          Gear for every stage—from first movement to structured play and advanced training.
        </p>
      </header>

      <div class="kids-store__hero-full">
        <KidsHeroSlider />
      </div>

      <div class="kids-store__catalog">
        <KidsProductCatalog />
      </div>
    </main>

    <MainFooter />
  </div>
</template>

<script>
import MainNavbar from "@/components/main/headernfooter/header.vue";
import MainFooter from "@/components/main/headernfooter/Footer.vue";
import KidsHeroSlider from "./components/KidsHeroSlider.vue";
import KidsProductCatalog from "./components/KidsProductCatalog.vue";
import KidsStoreNav from "./components/KidsStoreNav.vue";

export default {
  name: "KidsStore",
  components: {
    MainNavbar,
    MainFooter,
    KidsHeroSlider,
    KidsProductCatalog,
    KidsStoreNav,
  },
};
</script>

<style scoped src="./kidsStore.css"></style>
